import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

import { CLIENT_REFERRAL_LINK } from '~/src/components/ConnectDomruPopup/constants';

class ApplicationFormAnalytics extends BaseAnalytics {
    constructor() {
        super();

        this.category = 'application_form';
    }

    move() {
        this.send('move', CLIENT_REFERRAL_LINK);
    }

    moveStopper() {
        this.send('move_stopper', CLIENT_REFERRAL_LINK);
    }
}

class ApplicationFormHeaderAnalytics extends BaseAnalytics {
    constructor() {
        super();

        this.category = 'application_form_header';
    }

    move() {
        this.send('move', '[default_callback]');
    }

    moveStopper() {
        this.send('move_stopper', '[default_callback]');
    }
}

class ConnectPopupAnalytics extends BaseAnalytics {
    public applicationForm!: ApplicationFormAnalytics;
    public applicationFormHeader!: ApplicationFormHeaderAnalytics;

    constructor() {
        super();

        this.applicationForm = new ApplicationFormAnalytics();
        this.applicationFormHeader = new ApplicationFormHeaderAnalytics();
    }
}

const connectPopupAnalytics = new ConnectPopupAnalytics();

export default connectPopupAnalytics;
